var o = Object.prototype, i = o.hasOwnProperty;
function p(t) {
  var n = t.length, e = new t.constructor(n);
  return n && typeof t[0] == "string" && i.call(t, "index") && (e.index = t.index, e.input = t.input), e;
}
export {
  p as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_initCloneArray.js
// module id = 1479
// module chunks = 41